/*
* Auth
*/
export const AUTH_START = 'AUTH_START';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAILED = 'AUTH_SUCCESS';
export const LOGOUT = 'LOGOUT';

/*
* Profile
*/
export const GET_USER_INFO = 'GET_USER_INFO';
export const GET_USER_INFO_SUCCESS = 'GET_USER_INFO_SUCCESS';
export const GET_USER_CONTENT = 'GET_USER_CONTENT';
export const TOGGLE_ICON_CLICK = 'TOGGLE_ICON_CLICK';
export const TOGGLE_ICON_CLICK_DONE = 'TOGGLE_ICON_CLICK_DONE';
export const ADD_REMOVE_BUTTON_TOGGLE = 'ADD_REMOVE_BUTTON_TOGGLE';
export const REVIEW_REMOVE_SELECTION = 'REVIEW_REMOVE_SELECTION';
export const SELECT_TO_REMOVE_ITEM = 'SELECT_TO_REMOVE_ITEM';
export const ADD_BACK_ITEM = 'ADD_BACK_ITEM';
export const PERMANENT_REMOVE_ITEM = 'PERMANENT_REMOVE_ITEM';
export const GET_LATEST_USER_CONTENT = 'GET_LATEST_USER_CONTENT';
export const LEGEND_ITEM_CLICK = 'LEGEND_ITEM_CLICK';
export const LEGEND_ITEM_CLICK_DONE = 'LEGEND_ITEM_CLICK_DONE';
export const FILTER_ITEMS = 'FILTER_ITEMS';
export const FILTER_ITEMS_DONE = 'FILTER_ITEMS_DONE';
export const FILTER_BY_SIZE = 'FILTER_BY_SIZE';
export const FILTER_BY_SIZE_DONE = 'FILTER_BY_SIZE_DONE';
export const FILTER_BY_DATE = 'FILTER_BY_DATE';
export const FILTER_BY_DATE_DONE = 'FILTER_BY_DATE_DONE';
export const FILTER_BY_TYPE = 'FILTER_BY_TYPE';
export const FILTER_BY_TYPE_DONE = 'FILTER_BY_TYPE_DONE';
export const ITEM_DELETED = 'ITEM_DELETED';
export const ALL_ITEMS_DELETED = 'ALL_ITEMS_DELETED';

/*
* TreeMap Chart
*/
export const SHOW_CHART_ITEM_DETAIL = 'SHOW_CHART_ITEM_DETAIL';
export const CLOSE_CHART_ITEM_DETAIL = 'CLOSE_CHART_ITEM_DETAIL';
export const CLEAR_CHART_ITEM_DETAIL_DISPLAY = 'CLEAR_CHART_ITEM_DETAIL_DISPLAY';